(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0238"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0238"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ddjdx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99eb6571b1ffdfa9$export$2e2bcd8739ae039; });
function $99eb6571b1ffdfa9$export$2e2bcd8739ae039(e) {
    const isAccordionBtnAvalible = e.target.hasAttribute("data-accordion-btn");
    if (!isAccordionBtnAvalible) return;
    const accordionBtnRef = e.target;
    const accordionActiveBtnRef = e.currentTarget.querySelector(".active[data-accordion-btn]");
    if (accordionBtnRef === accordionActiveBtnRef) return $99eb6571b1ffdfa9$var$setAccordionActive(accordionBtnRef);
    if (accordionActiveBtnRef) $99eb6571b1ffdfa9$var$setAccordionActive(accordionActiveBtnRef);
    $99eb6571b1ffdfa9$var$setAccordionActive(accordionBtnRef);
}
function $99eb6571b1ffdfa9$var$setAccordionActive(accordionBtnRef) {
    const accordionBoxRef = accordionBtnRef?.closest("[data-accordion-box]");
    const accordionContentRef = accordionBoxRef?.querySelector("[data-accordion-content]");
    const expanded = accordionBtnRef.getAttribute("aria-expanded") === "true" || false;
    const hidden = accordionContentRef.getAttribute("aria-hidden") === "true" || false;
    accordionBtnRef?.classList.toggle("active");
    accordionBoxRef?.classList.toggle("active");
    accordionContentRef?.classList?.toggle("active");
    accordionContentRef.setAttribute("aria-hidden", !hidden);
    accordionBtnRef.setAttribute("aria-expanded", !expanded);
}

});


var $ddjdx = parcelRequire("ddjdx");
const $34a2af458d32a11e$var$articlePricesListRef = document.querySelector("[data-article-prices-list]");
$34a2af458d32a11e$var$articlePricesListRef?.addEventListener("click", (0, $ddjdx.default));

})();
//# sourceMappingURL=index.75fb5607.js.map
